import React from 'react';

export type ISessionContext = {
  id: string;
};

export const UNSET_SESSION_ID = 'unset';

const SessionContext = React.createContext<ISessionContext>({
  id: UNSET_SESSION_ID,
});

export default SessionContext;
